import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaCircle } from '@react-icons/all-files/fa/FaCircle';
import { FaProjectDiagram } from '@react-icons/all-files/fa/FaProjectDiagram';
import { FaCog } from '@react-icons/all-files/fa/FaCog';
import { FaHome } from '@react-icons/all-files/fa/FaHome';
import { FaPlus } from '@react-icons/all-files/fa/FaPlus';
import { FaCheckCircle } from '@react-icons/all-files/fa/FaCheckCircle';
import { FaTimesCircle } from '@react-icons/all-files/fa/FaTimesCircle';
import Breadcrumb from '../../../../commons/Breadcrumb';
import PageHeader from '../../../../commons/PageHeader';
import PageAlert, { usePageAlert } from '../../../../commons/PageAlert';
import Confirm, { useConfirm } from '../../../../commons/Confirm';
import { EditButton, DeleteButton, RenderActions } from '../../../../commons/DataGridActions';
import ProfaseDataGrid from '../../../../commons/Datagrid';
import { useAppDispatch, useAppSelector } from '../../../../store';
import { getEntities, deleteEntity, reset } from '../../../../manager/workflow-actividad.reducer';
import { sortBy } from 'lodash';
import BooleanCell from '../../../../commons/BooleanCell';
import ShieldIcon from '../../../../commons/ShieldIcon';

const BASE = '/configuracion/workflow/nodos';

export default function NodosPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const topRef = useRef<HTMLDivElement>(null);

  const entities = useAppSelector(s => s.workflowActividad.entities);
  const totalItems = useAppSelector(s => s.workflowActividad.totalItems);
  const loading = useAppSelector(s => s.workflowActividad.loading);
  const updating = useAppSelector(s => s.workflowActividad.updating);
  const updateSuccess = useAppSelector(s => s.workflowActividad.updateSuccess);

  const [rows, setRows] = useState<any[]>([]);
  const [lastParams, setLastParams] = useState<any>(null);

  const { alert, showToast } = usePageAlert();
  const { confirmConfig, ask, dismiss, setConfirmLoading } = useConfirm();

  useEffect(() => {
    const msg = (location.state as any)?.successMsg;
    if (msg) { showToast('success', msg); window.history.replaceState({}, ''); }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (updateSuccess) {
      dispatch(reset());
      dismiss();
      if (lastParams) dispatch(getEntities(lastParams));
      showToast('success', 'Nodo eliminado correctamente.');
    }
  }, [updateSuccess]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { setConfirmLoading(updating); }, [updating, setConfirmLoading]);

  useEffect(() => { setRows(entities ?? []); }, [entities]);

  const fetchData = (params: any) => {
    setLastParams(params);
    dispatch(getEntities(params));
  };

  const renderActions = (params: any) => (
    <></>
  );

  const cols = [
    { field: 'id', headerName: 'ID', flex: 0.5 },
    {
      field: 'profaseWorkflow.workflowClase.nombre', headerName: 'Clase', flex: 3,
      renderCell: (params: any) => {
        console.log('render params', params.row?.profaseActividad?.descripcion);
        return <span style={g.descripcion}>{params.row?.profaseWorkflow?.workflowClase?.nombre ?? '-- Sin Clase --'}</span>;
      }


    },
    {
      field: 'profaseWorkflow.nombre', headerName: 'Workflow', flex: 3,
      renderCell: (params: any) => {
        console.log('render params', params.row?.profaseActividad?.descripcion);
        return <span style={g.descripcion}>{params.row?.profaseWorkflow?.nombre ?? params.row?.tipoNodo}</span>;
      }


    },
    {
      field: 'tipoNodo', headerName: 'Tipo Nodo', flex: 4,
      renderCell: (params: any) => {
        console.log('render params', params.row?.profaseActividad?.descripcion);
        return <span style={g.descripcion}>{params.row?.tipoNodo ?? ' -- Sin Tipo --'}</span>;
      }
    },
    {
      field: 'profaseActividad.descripcion', headerName: 'Actividad', flex: 4,
      renderCell: (params: any) => {
        console.log('render params', params.row?.profaseActividad?.descripcion);
        return <span style={g.descripcion}>{params.row?.profaseActividad?.descripcion ?? '--'}</span>;
      }
    },
    {
      field: 'habilitado', headerName: 'Habilitado', flex: 1,
      renderCell: (params: any) => params.row.habilitado
        ? <FaCheckCircle style={{ color: '#16a34a', fontSize: 15 }} />
        : <FaTimesCircle style={{ color: '#94a3b8', fontSize: 15 }} />,
    },
    {
      field: 'requiereAutorizacion',
      headerName: 'Requiere Autorización',
      flex: 1.2,
      renderCell: (params: any) => { return <ShieldIcon show={true} strokeColor={params.row?.requiereAutorizacion ? 'black' : '#aaaaaa'} color={params.row?.requiereAutorizacion ? '#f59e0b' : '#cccccc'} ></ShieldIcon > },
    },
    { field: '__actions', headerName: '', flex: 1, renderCell: renderActions },
  ];

  const filters = [
    { label: 'Clase', name: 'profaseWorkflow.workflowClase.nombre' },
    { label: 'Nombre', name: 'profaseWorkflow.nombre' },
    { label: 'Actividad', name: 'profaseActividad.descripcion' },
  ];

  return (
    <div style={g.page} ref={topRef}>
      <Breadcrumb items={[
        { label: 'Inicio', to: '/', icon: <FaHome /> },
        { label: 'Configuración', to: '/configuracion', icon: <FaCog /> },
        { label: 'Workflow', to: '/configuracion/workflow', icon: <FaProjectDiagram /> },
        { label: 'Nodos', icon: <FaCircle /> },
      ]} />

      <PageHeader
        icon={<FaCircle />}
        iconColor="#10b981"
        title="Nodos"
        subtitle="Gestión de actividades de workflow"
      // action={{
      //   label: <><FaPlus style={{ marginRight: 6 }} />Nuevo Nodo</>,
      //   onClick: () => navigate(`${BASE}/new`),
      // }}
      />

      <Confirm config={confirmConfig} />
      {alert && <PageAlert alert={alert} />}

      <ProfaseDataGrid
        cols={cols}
        title=""
        filters={filters}
        fetch={fetchData}
        rowCount={totalItems}
        loading={loading}
        rows={rows}
      />
    </div>
  );
}

const g: Record<string, React.CSSProperties> = {
  page: { display: 'flex', flexDirection: 'column', gap: 24 },
  descripcion: { color: 'gray' },
};
